import type { UIState } from 'features/ui/ui-slice';

export function omitSessionUiFields(
  ui: UIState
): Omit<UIState, 'googleApiLoaded' | 'reproducingErrorLogId'> {
  const { googleApiLoaded, reproducingErrorLogId, ...next } = ui;
  return next;
}
